(() => {

  // ==========================
  // Configure all gift campaigns here
  // ==========================

  const GIFT_CAMPAIGNS = {
    "free-funnel": 51064157012256,              // 125 mL Separatory Funnel
    "free-vacuum-filtration": 39670833512510    // Vacuum Filtration Apparatus
  };

  let syncing = false;

  async function getCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  async function addGift(variantId, campaign) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          _auto_gift: campaign
        }
      })
    });
  }

  async function removeGift(lineKey) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0
      })
    });
  }

  async function syncGifts() {

    if (syncing) return;
    syncing = true;

    try {

      const cart = await getCart();

      for (const campaign in GIFT_CAMPAIGNS) {

        const giftVariant = GIFT_CAMPAIGNS[campaign];

        const qualifyingItem = cart.items.find(item =>
          item.properties &&
          item.properties._gift_campaign === campaign
        );

        const giftItem = cart.items.find(item =>
          item.properties &&
          item.properties._auto_gift === campaign
        );

        if (qualifyingItem && !giftItem) {
          await addGift(giftVariant, campaign);
        }

        if (!qualifyingItem && giftItem) {
          await removeGift(giftItem.key);
        }
      }

    } catch (err) {
      console.error('Free Gift Error:', err);
    }

    syncing = false;
  }

  function delayedSync() {
    setTimeout(syncGifts, 700);
  }

  document.addEventListener('DOMContentLoaded', delayedSync);

  document.addEventListener('click', delayedSync);

})();